import { Box, Skeleton, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Icons } from "@repo/ui";

export const HeaderContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        height: "100%",
    }),
);

export const HeaderTitle = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        mb: 0,
        pr: 4,
    }),
);

export const HeaderSubtitle = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mb: 4,
    }),
);

export const HeaderPersonDescription = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
        whiteSpace: "pre-wrap",
    }),
);

export const HeaderAmount = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);

export const MobileLinkWrapper = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        mt: "auto",
    }),
);

export const MobileCarretsRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        py: 0,
    }),
);

export const CaretLeftIcon = styled(Icons.CaretLeft)<{ hidden: boolean }>(({ theme, hidden }) =>
    theme.unstable_sx({
        width: "0.8rem",
        height: "1.3rem",
        color: "primary.main",
        visibility: hidden ? "hidden" : "initial",
    }),
);

export const CaretRightIcon = styled(Icons.CaretRight)<{ hidden: boolean }>(({ theme, hidden }) =>
    theme.unstable_sx({
        width: "0.8rem",
        height: "1.3rem",
        color: "primary.main",
        visibility: hidden ? "hidden" : "initial",
    }),
);

export const HeaderLoadingSkeleton = styled(Skeleton)({
    display: "inline-block",
    width: 50,
});
